// extracted by mini-css-extract-plugin
export default {"navbarList":"NavbarList_navbarList__cJqdC"};